import React, { Component } from "react";
import { Link } from "react-router-dom";
import UserImage from "../user_image";
import FollowButton from "../profile/follow_button";
class UserLine extends Component {
  state = {};
  render() {
    return (
      <div className="row max_width_500 pt-2">
        <div className="width_image_user">
          <UserImage user={this.props.user} />
        </div>
        <Link
          className="width_text_user btn cursor_btn align_element yaystack_color"
          to={{
            pathname: "/users/" + this.props.user.username
          }}
        >
          <div className="cursor_btn width_100">
            <label className="cursor_btn user_name">
              {this.props.user.first_name} {this.props.user.last_name}
            </label>
            <label className="cursor_btn user_username">
              {this.props.user.username}
            </label>
          </div>
          {/* <label className="btn cursor_btn">{this.props.user.username}</label> */}
        </Link>

        <div className="width_follow_user align_element">
          <FollowButton
            user={this.props.user}
            userlist={true}
            handleAddFriend={this.props.handleAddFriend}
            handleRemoveFriend={this.props.handleRemoveFriend}
          />
        </div>
      </div>
    );
  }
}

export default UserLine;



// WEBPACK FOOTER //
// ./src/components/users/user_line.jsx